import { Col, Form, Radio, Row, Select, Spin, Table } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { SelectForm } from 'components';
import TableComponent from 'components/Table/TableComponent';
import { ColumnsTypeCustom } from 'interfaces/Table/ColumnType';
import React, { useEffect, useState } from 'react';
import formatNumber, {
  formatCurrency,
  generateUUID,
} from 'utils/constants/functions';
import { OrderDebitType, PurchaseDebitType } from './DetailPaymentSummaryPage';

interface IProps {
  form: any;
  customerId: any;
  purchaseOrderSelected: any;
  purchaseOrdersData: any;
  setPurchaseOrderSelected: (value: any) => void;
  setSaleOrderSelected: (value: any) => void;
  setPurchaseType: (value: string) => void;
  loading: boolean;
  refetchSumPayment: (
    dataNewSaleOrder?: any,
    dataNewPurchaseOrder?: any,
  ) => any;
  lockYn?: boolean;
}

const TabPurchaseInvoice = (props: IProps) => {
  const {
    form,
    customerId,
    purchaseOrderSelected,
    purchaseOrdersData,
    setPurchaseOrderSelected,
    setSaleOrderSelected,
    setPurchaseType,
    loading,
    refetchSumPayment,
    lockYn,
  } = props;

  const columns: ColumnsTypeCustom = [
    {
      title: 'Tuổi vàng',
      width: 80,
      dataIndex: 'age',
      align: 'right',
      render: (value: any) => formatNumber(value),
    },
    {
      title: 'TL Tuổi vàng(chỉ)',
      width: 120,
      dataIndex: 'totalGoldWeightThread',
      align: 'right',
      render: (value: any) =>
        formatCurrency({
          value: Number(Number(value).toFixed(4)),
          format: 4,
        }),
    },
    {
      title: 'TL Q10(chỉ)',
      width: 100,
      dataIndex: 'totalq10',
      align: 'right',
      render: (value: any) =>
        formatCurrency({
          value: Number(Number(value).toFixed(4)),
          format: 4,
        }),
    },
    {
      title: 'TL Q10 sau điều chỉnh(chỉ)',
      width: 170,
      dataIndex: 'totalq10Accounting',
      align: 'right',
      render: (value: any) =>
        formatCurrency({
          value: Number(Number(value).toFixed(4)),
          format: 4,
        }),
    },
    {
      title: 'Thành tiền vàng',
      width: 200,
      dataIndex: 'totalFinalPrice',
      align: 'right',
      render: (value: any, record: any) =>
        formatNumber(
          record?.finalPriceAccounting && record?.finalPriceAccounting > 0
            ? record?.finalPriceAccounting
            : value,
        ),
    },
  ];

  const options = (purchaseOrdersData?.listPurchaseOrder || []).map(
    (item: any) => ({
      label: item.order_id,
      value: item.order_id,
    }),
  );

  useEffect(() => {
    // console.log('purchaseOrdersData', purchaseOrdersData);
  }, [purchaseOrdersData]);

  return (
    <Spin spinning={loading}>
      <Row gutter={16}>
        <Form.Item name={'purchaseType'} className="mb-2 ml-2">
          <Radio.Group
            disabled={lockYn}
            onChange={(e) => {
              const selectedValue = e.target.value;
              setPurchaseType(selectedValue);

              // Nếu chọn "Trả khách" thì reset bảng kê
              if (selectedValue === PurchaseDebitType.ReturnCustomer) {
                setSaleOrderSelected([]);
                form.setFieldsValue({ saleOrder: [] });
              }
              refetchSumPayment();
            }}
          >
            <Radio value={PurchaseDebitType.Q10}>Công nợ Q10</Radio>
            <Radio value={PurchaseDebitType.Amount}>Nợ Tiền</Radio>
            <Radio value={PurchaseDebitType.ReturnCustomer}>Trả khách</Radio>
          </Radio.Group>
        </Form.Item>
      </Row>
      <Form.Item name="purchaseOrder" className="mb-3">
        <SelectForm
          placeholder="Chọn bảng dẻ"
          mode="multiple"
          options={options}
          onChange={(value: any) => setPurchaseOrderSelected(value)}
          disabled={lockYn || !customerId}
        />
      </Form.Item>
      <TableComponent
        scroll={{ x: 'max-content' }}
        columns={columns}
        dataSource={purchaseOrdersData?.groupPurchaseOrder}
        rowKey={(record: any) => record?.id || generateUUID()}
        pagination={false}
        // loading={loading}
        summary={(pageData) => {
          return (
            <Table.Summary fixed>
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} align="end" className="font-bold">
                  Tổng
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1} align="end" className="font-bold">
                  {formatCurrency({
                    value: Number(
                      Number(
                        purchaseOrdersData?.totalGroupPurchaseOrder
                          ?.totalGoldWeightThread,
                      ).toFixed(4),
                    ),
                    format: 4,
                  })}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2} align="end" className="font-bold">
                  {formatCurrency({
                    value: Number(
                      Number(
                        purchaseOrdersData?.totalGroupPurchaseOrder?.totalq10,
                      ).toFixed(4),
                    ),
                    format: 4,
                  })}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3} align="end" className="font-bold">
                  {formatCurrency({
                    value: Number(
                      Number(
                        purchaseOrdersData?.totalGroupPurchaseOrder
                          ?.totalq10Accounting,
                      ).toFixed(4),
                    ),
                    format: 4,
                  })}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={4} align="end" className="font-bold">
                  {formatNumber(
                    purchaseOrdersData?.totalGroupPurchaseOrder
                      ?.totalFinalPrice,
                  )}
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          );
        }}
      />
    </Spin>
  );
};

export default TabPurchaseInvoice;
